import React, { useRef } from "react";
import {
    Button,
    Col,
    Glyphicon,
    Row,
    FormGroup,
    FormControl,
    ControlLabel,
    Table,
    ButtonGroup,
} from "react-bootstrap";
import { quizQuestionAnswerUpdate } from "../../../../../../api/cp";

const RatingMeasure = ({ poll, answer, setProperty, hasRating, onDelete }) => {
    const setAnswerProperty = (key, value) => {
        const _answer = { ...answer, [key]: value };
        setProperty('answer', poll.answer?.map(pollAnswer => pollAnswer?.id === _answer?.id ? _answer : pollAnswer));
    }

    const saveProperty = async (key, value) => {
        const response = await quizQuestionAnswerUpdate(answer.id, { [key]: value });
        if (response) {
            setProperty('answer', poll.answer?.map(pollAnswer => pollAnswer?.id === response?.id ? response : pollAnswer));
        }
    }

    return (
        <tr>
            <td style={{ width: '45%' }}>
                <FormControl
                    type="text"
                    value={answer.textRu}
                    onChange={e => setAnswerProperty('textRu', e.target.value)}
                    onBlur={e => saveProperty('textRu', answer.textRu)}
                    placeholder="Название"
                />
            </td>
            <td style={{ width: '45%' }}>
                <FormControl
                    type="text"
                    value={answer.textEn}
                    onChange={e => setAnswerProperty('textEn', e.target.value)}
                    onBlur={e => saveProperty('textEn', answer.textEn)}
                    placeholder="Title"
                />
            </td>
            <td style={{ width: '10%' }}>
                {hasRating && (
                    <FormControl
                        type="number"
                        value={answer.ratingMax}
                        max={10}
                        min={2}
                        onChange={e => setAnswerProperty('ratingMax', parseInt(e.target.value))}
                        onBlur={e => saveProperty('ratingMax', answer.ratingMax)}
                    />
                )}
            </td>
            <td style={{ width: '10px' }}>
                <Button onClick={onDelete}>
                    <Glyphicon glyph="remove" />
                </Button>
            </td>
        </tr>
    )
}

export default ({ poll, setProperty, saveProperty, savePropertyFile, createAnswer, deleteAnswer }) => {
    const imageInputRef = useRef(null);

    if (!poll) return null;

    const hasSkipAnswer = !!poll.answer?.some(({type}) => type === 'skip');

    return <>
        <FormGroup>
            <Row>
                <Col xs={6}>
                    <ControlLabel>Вопрос [Ru]</ControlLabel>
                    <FormControl
                        type="textarea"
                        value={poll.textRu}
                        onChange={e => setProperty('textRu', e.target.value)}
                        onBlur={(e) => saveProperty('textRu', poll.textRu)}
                        placeholder="Вопрос"
                    />
                </Col>
                <Col xs={6}>
                    <ControlLabel>Вопрос [En]</ControlLabel>
                    <FormControl
                        type="textarea"
                        value={poll.textEn}
                        onChange={e => setProperty('textEn', e.target.value)}
                        onBlur={(e) => saveProperty('textEn', poll.textEn)}
                        placeholder="Question"
                    />
                </Col>
            </Row>
        </FormGroup>
        <FormGroup>
            <Row>
                <Col xs={6}>
                    <FormGroup>
                        <ControlLabel>Изображение вопроса</ControlLabel>
                        {poll.imageUrl && <div><img src={poll.imageUrl} style={{ maxWidth: '100%', maxHeight: 120 }} alt="" /></div>}
                        <div>
                            <Button onClick={() => imageInputRef.current?.click()}><Glyphicon glyph="folder-open" /></Button>
                            {' '}
                            {poll.imageUrl && <Button onClick={() => savePropertyFile('image', 'DELETE')} bsStyle="danger"><Glyphicon glyph="trash" /></Button>}
                        </div>
                        <FormControl
                            type="file"
                            onChange={(e) => savePropertyFile('image', e.target.files[0] || null)}
                            inputRef={ref => imageInputRef.current = ref}
                            style={{ display: 'none' }}
                        />
                    </FormGroup>
                </Col>
            </Row>
        </FormGroup>
        <FormGroup>
            <Table>
                <thead>
                    <tr>
                        <th><ControlLabel>Критерий [Ru]</ControlLabel></th>
                        <th><ControlLabel>Критерий [En]</ControlLabel></th>
                        <th><ControlLabel>Размер шкалы</ControlLabel></th>
                        <th>{' '}</th>
                    </tr>
                </thead>
                <tbody>
                    {poll.answer?.sort((a, b) => a.order - b.order)?.map((answer, index) =>
                        <RatingMeasure
                            key={`poll_answer_${index}`}
                            poll={poll}
                            answer={answer}
                            hasRating={answer.type !== 'skip'}
                            setProperty={setProperty}
                            onDelete={() => deleteAnswer(answer)}
                        />
                    )}
                </tbody>
                <tfoot>
                    <tr>
                        <td colSpan={4}>
                            <Button onClick={() => createAnswer({ ratingMax: 5 })}>Добавить критерий</Button>
                            {!hasSkipAnswer && (
                                <Button
                                    style={{ marginLeft: '12px' }}
                                    onClick={() => createAnswer({ textRu: 'Пропустить', textEn: 'Skip', type: 'skip' })}
                                >
                                    Добавить пропуск вопроса
                                </Button>
                            )}
                        </td>
                    </tr>
                </tfoot>
            </Table>
        </FormGroup>
    </>
}
